// extracted by mini-css-extract-plugin
export var sponsors = "Sponsors-module--sponsors--YmHSx";
export var sponsorsWrapper = "Sponsors-module--sponsorsWrapper--1PtKQ";